import styled from 'styled-components';

interface SkeletonProps {
  height?: number;
  width?: number;
}

export const Skeleton = styled.div<SkeletonProps>`
  display: flex;
  width: ${({ width }) => (width ? `${width}rem` : '100%')};
  height: ${({ height }) => (height ? `${height}rem` : '100%')};
  background: ${({ theme }) => theme.neutralLight};
  border-radius: 1rem;
`;